const initialState = {
  authenticated: false,
  username: null,
  roles: [],
  isValidating: false,
  errorMessage: null,
  sessionChecking: false,
  userDataReady: false,
  correoElectronico: null,
  telefono: null
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'VALIDATING_USER':
      return {
        ...state,
        isValidating: true,
        authenticated: false,
        roles: [],
        username: null,
        errorMessage: null,
        userDataReady: false
      }
    case 'VALIDATED_USER':
      return {
        ...state,
        isValidating: false,
        authenticated: true,
        username: action.user,
        roles: action.roles,
        userDataReady: true
      }
    case 'INVALID_USER':
      return {
        ...state,
        isValidating: false,
        authenticated: false,
        username: null,
        roles: [],
        errorMessage: action.message,
        userDataReady: true
      }
    case 'START_CHECK_SESSION':
      return {
        ...state,
        userDataReady: false,
        sessionChecking: false
      }
    case 'END_CHECK_SESSION':
      return {
        ...state,
        userDataReady: true,
        sessionChecking: true,
        authenticated: action.authenticated,
        username: action.user,
        roles: action.roles
      }
    case 'USER_LOGGED_OUT':
      return {
        ...initialState,
        userDataReady: true
      }
    case 'USER_LOGGED_OUT_PREVENT':
      return {
        ...initialState,
        userDataReady: true
      }
    case 'RECEIVE_CONSULTA_INFO_USER':
      return {
        ...state,
        correoElectronico: action.data.mail,
        telefono: action.data.telefono
      }
    default:
      return state
  }
}
